module.exports = __webpack_public_path__ + "img/logout.2422e3c2.svg";